export default __webpack_public_path__ + "static/media/5.347b5f49.png";